<template>
  <master-main
    :addProperties="{
      isWizard: false,
    }"
    :exportProperties="{
      pdf: {
        filename: `${$t('shopping.approval_ranges')}_${dateToday}.pdf`,
        route: `${getModuleRoute}/pdf`,
      },
      xls: {
        filename: `${$t('shopping.approval_ranges')}_${dateToday}.xlsx`,
        route: `${getModuleRoute}/excel`,
      },
    }"
    :route="getModuleRoute"
    :showProperties="showProperties"
    :tableProperties="tableProperties"
    :refreshDetail="refreshDataDetail"
    @closeModal="handleCloseModal"
    @openModal="handleOpenModal"
    @refresh="refresh"
    @showHideLoading="showHideLoading"
    @showNotification="notifyVue"
    ref="masterMain"
  >
    <template slot="dialogForm">
      <edit-or-create
        v-if="renderComponent"
        :syncDialog="modals"
        @addEdit="addEdit"
        @closeModal="handleCloseModal"
        @showHideLoading="showHideLoading"
        @showNotification="notifyVue"
        @refreshDetail="refreshDetail"
        ref="editCreate"
      />
    </template>
  </master-main>
</template>
<script>
import { getDateToday } from 'src/util/Util';
import ApprovalRangeTable from 'src/views/Pages/Dashboard/Supplying/Shopping/ApprovalRange/approval-ranges-table';
import EditCreate from 'src/views/Pages/Dashboard/Supplying/Shopping/ApprovalRange/EditCreate.vue';
import MasterMain from 'src/components/Layouts/Masters/MasterMain.vue';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinMain from 'src/mixins/master/mixin-main';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinRerender from 'src/mixins/mixin-rerender';
import MixinWithDialog from 'src/mixins/master/mixin-with-dialog';

export default {
  components: {
    MasterMain,
    [EditCreate.name]: EditCreate,
  },
  data() {
    return {
      refreshDataDetail: {},
      tableProperties: {},
      showProperties: { size: '80%' },
    };
  },
  mixins: [
    MixinAlert,
    MixinLoading,
    MixinForm,
    MixinMain,
    MixinPermissions,
    MixinWithDialog,
    MixinRerender,
    MixinMenu,
  ],
  computed: {
    getModuleRoute() {
      return 'shopping/approvalrange';
    },
    buildTableProperties() {
      return {
        tableColumns: [...ApprovalRangeTable().tableColumns],
        model: 'approvalrangeheader',
        effectTags: 'dark',
        defaultSort: { order: 'ascending' },
      };
    },
    dateToday() {
      return getDateToday();
    },
  },
  methods: {
    refreshDetail(refreshDetail) {
      this.refreshDataDetail = refreshDetail;
    },
  },
};
</script>
